/**
 * Flatten a nested messages object into dot-notation keys for react-intl.
 * { common: { save: "Save" } }  →  { "common.save": "Save" }
 */
export function flattenMessages(
  nestedMessages: Record<string, unknown>,
  prefix = ''
): Record<string, string> {
  const flat: Record<string, string> = {};

  for (const [key, value] of Object.entries(nestedMessages)) {
    const fullKey = prefix ? `${prefix}.${key}` : key;
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
      Object.assign(flat, flattenMessages(value as Record<string, unknown>, fullKey));
    } else {
      flat[fullKey] = String(value);
    }
  }

  return flat;
}
